// @flow
import { createListenerMiddleware } from '@reduxjs/toolkit';

const appInterfaceMiddleware = createListenerMiddleware();

const actionMap = [
  ['VEHICLE_ADDED', 'vehicle/CREATE_VEHICLE_SUCCESS'],
  ['VEHICLE_DELETED', 'vehicle/deleteUserVehicle/fulfilled'],
  ['PAYMENT_METHOD_ADDED', 'payments/createPaymentMethod/fulfilled'],
  ['PAYMENT_METHOD_DELETED', 'payments/deletePaymentMethod/fulfilled'],
  ['CHANGE_EMAIL', 'profile/submitEmail/fulfilled'],
  ['CHANGE_DETAILS', 'profile/submitDetails/fulfilled'],
  ['PASSWORD_RESET_REQUEST', 'profile/sendResetPasswordLink/fulfilled'],
  ['CHANGE_ADDRESS', 'profile/SUBMIT_ADDRESS_SUCCESS']
];
actionMap.forEach(([value, type]) =>
  appInterfaceMiddleware.startListening({
    type,
    effect: () => {
      if (
        __CLIENT__ &&
        'AppInterface' in window &&
        'updateProfile' in window.AppInterface
      ) {
        window.AppInterface.updateProfile(value);
      }
    }
  })
);

export default appInterfaceMiddleware;
